import { doRequest } from "utils/core";

const noticeAPI = {
  getNotices: (params) => {
    const url = `api/notice/index`;
    return doRequest("get", url, { params });
  },
  getInitNotice: (params) => {
    const url = `api/notice/init`;
    return doRequest("get", url, { params });
  },
  getNotice: (params) => {
    const url = "api/notice/detail";
    return doRequest("get", url, { params });
  },
};

export default noticeAPI;
